import { AxiosResponse } from 'axios';
import { HttpResponse } from 'shell/models/http-response';
import { SubjectsList, ResponseAnprData, SubjectData } from 'shell/models/person';
import { transformPerson } from 'shell/utils/consult-person/response-transformer/person/person';
import {
  PersonVM,
  RegistrationBewareFormVM,
  SubjectAttributesVM,
} from 'mutation/view-models/registration-beware';
import { transformerPersonList } from 'shell/utils/transform-person-list';
import { DateTime } from 'luxon';
import { CitizenshipVM } from 'shell/view-models/citizenship';
import { AccordionFamilyCoexistence } from 'shell/view-models/accordion-family-coexistence';
import { transformFamilyCoexistence } from 'shell/utils/consult-person/response-transformer/family/family-coexistence';
import { transformCitizenship } from 'shell/utils/consult-person/response-transformer/registry-office/citizenship';

export const initialValues: RegistrationBewareFormVM = Object.freeze({
  changeControlDataForm: {
    effectiveDate: DateTime.local(),
    validationFiscalCode: '',
  },
  subjectAttributes: {
    disabled: true,
    typology: '',
    isForeign: false,
    // italian
    municipalityItalian: null,
    // foreign
    municipalityForeign: null,
    foreignState: null,
    dateForm: null,
    year: '',
    note: '',
  },
  registrationNewPerson: {
    typology: undefined,
    fiscalCode: undefined,
    surname: undefined,
    name: undefined,
    gender: undefined,
    birthDate: null,
    birthChoiceDate: undefined,
    isForeignBirth: false,
    italianBirth: {
      municipality: undefined,
    },
    foreignBirth: {
      foreignState: undefined,
      foreignMunicipality: undefined,
    },
    isForeignDomicile: false,
    italianDomicile: {
      municipality: undefined,
    },
    foreignDomicile: {
      foreignState: undefined,
      foreignMunicipality: undefined,
    },
    address: undefined,
  },
});

export const transformerRegistrationBewareData = (
  response: AxiosResponse<HttpResponse<SubjectsList>>
): RegistrationBewareFormVM => {
  const person = response.data?.payload?.datiSoggetto || [];

  let personData: PersonVM | undefined = undefined;
  let familyCoexistence: AccordionFamilyCoexistence | undefined = undefined;
  let citizenship: Array<CitizenshipVM> | undefined = undefined;
  let subjectAttributes: SubjectAttributesVM = {};

  let disabled = true;

  if (person.length > 1) {
    // se ci sono più risultati formattare la tabella
    const data: AxiosResponse<HttpResponse<ResponseAnprData>> = formattedDataList(person);

    const bodyTable = transformerPersonList(data);

    personData = {
      personsList: bodyTable || [],
    };
  }

  if (person.length === 1) {
    // ritorna un solo elemento
    personData = transformPerson(person[0]) as PersonVM;
    personData.codicePersonaSipo = person[0]?.codicePersonaSipo;
    familyCoexistence = transformFamilyCoexistence(person[0]);
    citizenship = transformCitizenship(person[0]);

    subjectAttributes = {
      homeless: person[0]?.attributiSoggetto?.senzaFissaDimora === 'S',
      certificableSubject: person[0]?.attributiSoggetto?.soggettoCertificabile || '2',
    };
    disabled = false;
  }

  if (person.length === 0) {
    // la ricerca non ha effettuato nessun risultato
    personData = {
      openModal: true,
    };
  }

  return {
    searchPerson: person.length !== 1 ? personData : null,
    person: personData,
    familyCoexistence,
    citizenship,
    subjectAttributes: {
      ...initialValues.subjectAttributes,
      ...subjectAttributes,
      disabled,
    },
    registrationNewPerson: {
      ...initialValues.registrationNewPerson,
    },
    changeControlDataForm: {
      effectiveDate: DateTime.local(),
      validationFiscalCode: '',
    },
  };
};

const formattedDataList = (
  person: Array<SubjectData>
): AxiosResponse<HttpResponse<ResponseAnprData>> => {
  return {
    data: {
      payload: {
        risposta3002OK: {
          listaSoggetti: {
            datiSoggetto: person,
          },
          testataRisposta: {},
          datiFamigliaConvivenza: {
            residenza: {
              tipoIndirizzo: '',
              noteIndirizzo: '',
              indirizzo: {
                cap: '',
                comune: {},
                frazione: '',
                toponimo: {
                  codSpecie: '',
                  specie: '',
                  specieFonte: '',
                  codToponimo: '',
                  denominazioneToponimo: '',
                  toponimoFonte: '',
                },
                numeroCivico: {
                  codiceCivico: '',
                  civicoFonte: '',
                  numero: '',
                  metrico: '',
                  progSNC: '',
                  lettera: '',
                  esponente1: '',
                  colore: '',
                  civicoInterno: {
                    corte: '',
                    scala: '',
                    interno1: '',
                    espInterno1: '',
                    interno2: '',
                    espInterno2: '',
                    scalaEsterna: '',
                    secondario: '',
                    piano: '',
                    nui: '',
                    isolato: '',
                  },
                },
              },
              localitaEstera: {
                indirizzoEstero: {
                  cap: '',
                  localita: {
                    descrizioneLocalita: '',
                    descrizioneStato: '',
                    codiceStato: '',
                    provinciaContea: '',
                  },
                  toponimo: {
                    denominazione: '',
                    numeroCivico: '',
                  },
                },
                consolato: {},
              },
              presso: '',
              dataDecorrenzaResidenza: '',
            },
            famigliaConvivenza: {
              idFamigliaConvivenzaComune: {},
            },
          },
          listaAnomalie: {
            errore: [],
          },
        },
        rispostaKO: {
          testataRisposta: {},
          listaErrori: {
            errore: [],
          },
        },
      },
      summary: {
        code: '',
        error: false,
        messages: [],
      },
    },
    status: 0,
    statusText: '',
    headers: {},
    config: {},
  };
};
